import {
    IParticipantDraft,
    IRegistrationField,
    IRegistrationForm,
    IRegistrationSelections,
} from '../Interfaces/IEventRegistration';

/** Muss mit `MAX_GUESTS_PER_RSVP` in `backend/calendarapp/models.py` uebereinstimmen. */
export const MAX_GUESTS_PER_RSVP = 20;

export interface ParticipantValidationResult {
    participantIndex: number;
    label: string;
    missingFieldLabels: string[];
}

/**
 * Anzeigename eines Teilnehmers in Formular und Fehlermeldungen. Spiegelt
 * `_participant_label` im Backend: der Nutzer sieht nie technische Begriffe.
 */
export const participantDisplayLabel = (participant: IParticipantDraft, index: number): string => {
    if (participant.kind === 'MEMBER') {
        return 'Deine Angaben';
    }
    const name = participant.name.trim();
    return name || `Gast ${index}`;
};

/** SINGLE verlangt genau eine, MULTI mindestens eine Option -- identisch zum Backend. */
export const isFieldSatisfied = (
    field: IRegistrationField,
    selections: IRegistrationSelections
): boolean => {
    const selected = selections[String(field.id)] ?? [];
    const unique = new Set(selected);
    if (field.selection_type === 'SINGLE') {
        return unique.size === 1;
    }
    return unique.size >= 1;
};

/**
 * Welche Teilnehmer haben welche Bereiche noch offen? Nur fuer die UX -- die
 * verbindliche Pruefung laeuft serverseitig (Spec §10).
 */
export const validateRegistrationDraft = (
    form: IRegistrationForm | null,
    participants: IParticipantDraft[]
): ParticipantValidationResult[] => {
    const fields = form?.fields ?? [];
    if (fields.length === 0) {
        return [];
    }

    return participants
        .map((participant, participantIndex) => ({
            participantIndex,
            label: participantDisplayLabel(participant, participantIndex),
            missingFieldLabels: fields
                .filter((field) => !isFieldSatisfied(field, participant.selections))
                .map((field) => field.label),
        }))
        .filter((result) => result.missingFieldLabels.length > 0);
};

export const isRegistrationComplete = (
    form: IRegistrationForm | null,
    participants: IParticipantDraft[]
): boolean => validateRegistrationDraft(form, participants).length === 0;
